import { render, staticRenderFns } from "./SideBarFilter.vue?vue&type=template&id=bb563226&scoped=true"
import script from "./SideBarFilter.vue?vue&type=script&lang=js"
export * from "./SideBarFilter.vue?vue&type=script&lang=js"
import style0 from "./SideBarFilter.vue?vue&type=style&index=0&id=bb563226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb563226",
  null
  
)

export default component.exports